import { render, staticRenderFns } from "./CalendarTag.vue?vue&type=template&id=7907065c&scoped=true&"
import script from "./CalendarTag.vue?vue&type=script&lang=js&"
export * from "./CalendarTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7907065c",
  null
  
)

export default component.exports